import React from "react";
import "../css/NoData.css";
import { MdOutlineFolderOff } from "react-icons/md";

function NoData({ fold = false, info = "No data", style }) {
  return (
    <div className={`nodata-content${fold ? "-folded" : ""}`} style={style}>
      <div className="nodata-icon">
        <MdOutlineFolderOff style={{ fontSize: "50px", color: "#BBBBBB" }} />
      </div>

      <div className="nodata-info">{info}</div>
    </div>
  );
}

export default NoData;
